module.exports = __webpack_public_path__ + "assets/img/3-2.f04277eb.svg";